import * as React from 'react';
import { useTheme } from 'styled-components';
import { m } from 'framer-motion';
import Wrapper from './Wrapper';
import { NodeText } from './Text';
import { Element } from './Elements';
import Icon from './Icon';
import Icons from '../assets/images/Icons';
var DefaultIcon = Icons['file'];
var LeafElement = React.forwardRef(function (_a, ref) {
    var data = _a.data, _b = _a.selected, selected = _b === void 0 ? false : _b, _c = _a.level, level = _c === void 0 ? 0 : _c, _d = _a.currentTheme, currentTheme = _d === void 0 ? 'dark' : _d, _e = _a.noIcons, noIcons = _e === void 0 ? false : _e, _f = _a.didToggleSelect, didToggleSelect = _f === void 0 ? function () { } : _f, _g = _a.LeafRenderer, LeafRenderer = _g === void 0 ? null : _g, _h = _a.IconRenderer, IconRenderer = _h === void 0 ? null : _h, _j = _a.borderTop, borderTop = _j === void 0 ? false : _j;
    if (data === null) {
        return null;
    }
    var theme = useTheme();
    var handleClick = React.useCallback(function (e, nodeId) {
        didToggleSelect(nodeId, e.metaKey || e.ctrlKey);
    }, [data]);
    var renderedIcon = IconRenderer && typeof IconRenderer === 'function' ? (React.createElement(Icon, { size: "large", currentTheme: currentTheme },
        React.createElement(IconRenderer, { label: "leaf" }))) : (React.createElement(Icon, { size: theme._themes[currentTheme || 'dark'].textSize, defaultIcon: true, currentTheme: currentTheme },
        React.createElement(DefaultIcon, null)));
    var content = typeof LeafRenderer === 'function' ? (React.createElement("div", { title: data.label, ref: ref, "data-node-id": data.id, onClick: function (e) { return handleClick(e, data.id); } }, LeafRenderer({ data: data, selected: selected, level: level }))) : (React.createElement("div", { ref: ref },
        React.createElement(Element, { title: data.label, borderTop: borderTop, "data-node-id": data.id, selected: selected, currentTheme: currentTheme, onClick: function (e) { return handleClick(e, data.id); } },
            React.createElement(Wrapper, { level: level + 1 },
                !noIcons && React.createElement("span", { style: { paddingRight: '8px' } }, renderedIcon),
                React.createElement(NodeText, null, data.label)))));
    return content;
});
var MotionLeafElement = m(LeafElement, { forwardMotionProps: true });
export default MotionLeafElement;
//# sourceMappingURL=LeafElement.js.map